export enum InitialDisclaimerDisplay {
    LONG = 'LONG',
    SHORT = 'SHORT'
}
